import script from "./index.vue?vue&type=script&lang=jsx&setup=true"
export * from "./index.vue?vue&type=script&lang=jsx&setup=true"

import "./index.vue?vue&type=style&index=0&id=41958c0c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41958c0c"]])

export default __exports__